import React from 'react';
import PropTypes from 'prop-types';
import { DateTimeForm } from './search-date-time-form';
import { DropDownBtn } from '../dropdown-btn';
import { InputAddOn } from '../input-group-addon';
import searchByDateTimeHOC from './search-date-time-hoc';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';

class SearchDateTimeButton extends React.Component {
  constructor(props) {
    super(props);
    this.dropDownBtn = null;
  }
  close () {
    if (this.dropDownBtn.hideDropDown) {
      this.dropDownBtn.hideDropDown(); // Call the method exposed by DropDownBtn
    }
  }

  render () {
    const { selectedDate, selectedDateString, inputRef, buttonClassName, defaultLabel, containerClassName, openOnLoad, ...rest } = this.props;
    return (
      <div>
        <InputAddOn
          leftAddon={this.props.addOnImage}
        >
          <DropDownBtn
            ref={ref => {
              this.dropDownBtn = ref;
            }}
            onHideFn={this.props.onHideFn}
            mobileViewOff
            openOnLoad={openOnLoad}
            buttonId="search-date-time-btn"
            containerClassName={containerClassName}
            buttonClassName={`remove-click-styling search-date-dropdown ${buttonClassName}`}
            buttonChildren={
              <div className="ellipsis">
                {
                  this.props.displayDateTime || defaultLabel ||
                  <FormattedMessage id="shared_components.search_date_time_button.default_label" defaultMessage="When?" />
                }
              </div>
            }
          >
            <DateTimeForm
              {...rest}
              selectedDate={selectedDate}
              dateColClass="border-right"
              intl={this.props.intl}
            />
          </DropDownBtn>
        </InputAddOn>
        <input
          ref={ ref => {
            if ('function' === typeof inputRef) inputRef(ref);
          }
          }
          type="hidden"
          readOnly
          data-value={selectedDateString}
          value={selectedDate ? moment(selectedDate).format('ll') : ''}
        />
      </div>
    );
  }
}

SearchDateTimeButton.propTypes = {
  dropDownBtnRef: PropTypes.func,
  onHideFn: PropTypes.func,
  displayDateTime: PropTypes.string,
  addOnImage: PropTypes.element,
  selectedDate: PropTypes.string,
  selectedDateString: PropTypes.string,
  inputRef: PropTypes.func,
  buttonClassName: PropTypes.string,
  defaultLabel: PropTypes.string
};

export default searchByDateTimeHOC(SearchDateTimeButton);
